import { buildJupiterStep } from './step-builders'
import type { RouteContext, RouteStep, RouteStrategy, StepStatus } from './types'
import { findStep } from '@/features/crosschain-buy/domain/progress'

class RangoStrategy implements RouteStrategy {
  compute(ctx: RouteContext): RouteStep[] {
    const hasJupiterPreStep = ctx.rangoJupiterPreStep
    const solAmountHuman = ctx.rangoSolAmount
    const tonUsdSuffix = ctx.bridgeOutputUsd ? ` (${ctx.bridgeOutputUsd})` : ''
    const steps: RouteStep[] = []

    if (hasJupiterPreStep) {
      const jupiterOutputLabel = solAmountHuman ? `~${solAmountHuman} SOL` : '... SOL'
      steps.push(
        buildJupiterStep(
          ctx.sourceAmount,
          ctx.fromToken,
          jupiterOutputLabel,
          ctx.state,
          ctx.step1Status,
          ctx.jupiterTxUrl
        )
      )
    }

    const jupiterDone =
      hasJupiterPreStep && findStep(ctx.state, 'jupiter_swap')?.status === 'completed'
    const bridgeStatus: StepStatus = !hasJupiterPreStep || jupiterDone ? ctx.step1Status : 'pending'
    const solLabel = solAmountHuman ? `${solAmountHuman} SOL` : 'SOL'
    const bridgeAmountIn = hasJupiterPreStep ? solLabel : `${ctx.sourceAmount} ${ctx.fromToken}`
    const bridgeAmountOut = ctx.bridgeOutputAmount ? `~${ctx.bridgeOutputAmount}` : '...'

    steps.push({
      key: 'bridge',
      label: 'Bridge via Rango',
      amountLine: `${bridgeAmountIn} → ${bridgeAmountOut} GRAM${tonUsdSuffix}`,
      amountLoading: false,
      status: bridgeStatus,
      txLinks: ctx.bridgeTxLinks,
      etaHint: ctx.bridgeEtaHint,
    })

    const spottyOut = ctx.spottyAmount ? `~${ctx.spottyAmount}` : '...'
    steps.push({
      key: 'ton_to_spotty',
      label: 'Swap via STON.fi',
      amountLine: ctx.bridgeOutputAmount
        ? `${ctx.bridgeOutputAmount} GRAM → ${spottyOut} SPOTTY`
        : 'GRAM → SPOTTY',
      amountLoading: ctx.previewLoading && !ctx.spottyAmount,
      status: ctx.step2Status,
      txLinks:
        ctx.step2Status !== 'pending' && ctx.tonTxUrl
          ? [{ url: ctx.tonTxUrl, label: 'View tx' }]
          : [],
      etaHint: null,
    })

    return steps
  }
}

export const rangoStrategy = new RangoStrategy()
